'use client';
import { useT } from '../../i18n';

export function SectionKicker({ children }: { children: React.ReactNode }) {
  return <div className="section-kicker"><span className="scan-corners" />{children}</div>;
}

export function LandLinkMark({ compact = false, onClick }: { compact?: boolean; onClick?: () => void }) {
  const t = useT();
  const content = (
    <>
      <span className="landlink-symbol"><i /><i /><i /></span>
      <span className="landlink-name">{t('landlink.brandName')}<small>LANDLINK</small></span>
    </>
  );
  if (onClick) {
    return (
      <button className={`landlink-brand ${compact ? "compact" : ""}`} onClick={onClick} aria-label={t('landlink.backAria')}>
        {content}
      </button>
    );
  }
  return (
    <a className={`landlink-brand ${compact ? "compact" : ""}`} href="#" aria-label={t('landlink.brandAria')}>
      {content}
    </a>
  );
}
